import { Page } from '@/core/architecture'

import { ArtistRankingTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistRanking Page
 * Implemented as a practical sample.
 */
export const ArtistRanking: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistRankingTemplate state={state} {...actions} />
}
